import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonProvider } from '../../providers/common/common';
import { Events } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import JsBarcode from 'jsbarcode';

@Component({
  selector: 'member-card',
  templateUrl: 'member-card.html'
})
export class MemberCardComponent {
  @Input() page_name:string;
  @Output() returnDispBarcode = new EventEmitter<boolean>();
  service_data = [];
  card_data = [];
  user_data = [];
  clock = this.comProv.getClock();
  interval_clock;
  is_login:boolean;
  is_app:boolean;
  disp_barcode:boolean = false;
  is_bright:boolean = false;
  text_member_unregistered = this.translate.get('text_member_unregistered')['value'];
  noset_height = '70px';

  constructor(
    public comProv: CommonProvider,
    public events: Events,
    public translate: TranslateService,
  ) {
    this.service_data = this.comProv.getService();
    this.card_data = this.service_data['app_membership_card'];
    this.user_data = this.comProv.getUser();
    this.is_login = this.comProv.isLogin();
    this.is_app = this.comProv.isApp();

    this.events.subscribe('member-card:dark', () => {
      this.setDark();
      clearInterval(this.interval_clock);
    });
  }

  ngOnInit () {
    console.log('ngOnInit');
    if (this.page_name == 'member') {
      this.noset_height = '100px';
    }
  }

  ngAfterContentInit() {
    this.dispBarcode();
  }

  ngOnDestroy() {
    this.setDark();
    clearInterval(this.interval_clock);
  }

  changeMemberCode(member_code) {
    console.log('changeMemberCode', member_code);
    this.user_data['member_code'] = member_code;
    if (this.user_data['member_code']) {
      this.dispBarcode();
    } else {
      this.setDark();
      this.disp_barcode = false;
      this.text_member_unregistered = this.translate.get('text_member_unregistered')['value'];
      this.returnDispBarcode.emit(this.disp_barcode);
    }
  }

  dispBarcode() {
    if (this.card_data['is_barcode'] != 1) {
      return;
    }
    if (!this.is_login) {
      return;
    }
    if (!this.card_data['barcode_format']) {
      if (this.page_name == 'member') {
        this.comProv.dispAlert('バーコードのフォーマットが設定されていません。');
      }
      return;
    }
    if (!this.card_data['is_user_id_barcode']) {
      if (!this.user_data['member_code']) {
        return;
      }

      if (!this.comProv.checkBarcodeFormat(this.user_data['member_code'])) {
        //this.comProv.dispAlert(this.translate.get('message_member_barcode_not_matching')['value']);
        this.text_member_unregistered = this.translate.get('message_member_barcode_not_matching')['value'];
        return;
      }
    }
    
    try {
      let height = 50;
      if (this.page_name == 'wfk') {
        height = 90;
      }
      let barcode_style = {
        format: this.card_data['barcode_format'],
        fontSize: 16,
        height: height,
        margin: 5,
      };
      let barcode_string = '';
      if (this.card_data['is_user_id_barcode']) {
        if (this.service_data['option']['member_barcode_pattern']) {
          barcode_string = this.comProv.generateBarcodeString(this.user_data['id'], this.service_data['option']['member_barcode_pattern'], this.card_data['barcode_format']);
        } else {
          barcode_string = this.user_data['id'];
        }
      } else {
        barcode_string = this.user_data['member_code'];
      }
      JsBarcode('#barcode_id', barcode_string, barcode_style);

      /*if (this.card_data['is_user_id_barcode']) {
        JsBarcode('#barcode_id', this.user_data['id'], barcode_style);
      } else {
        JsBarcode('#barcode_id', this.user_data['member_code'], barcode_style);
      }*/

      this.disp_barcode = true;
      this.returnDispBarcode.emit(this.disp_barcode);
      if (this.page_name != 'home') {
        this.interval_clock = setInterval(() => {
          this.clock = this.comProv.getClock();
        }, 1000)
      }
      if (this.page_name == 'member') {
        setTimeout(() => {
          this.setBright();
        }, 100)
      }
    } catch(e) {
      //this.comProv.dispAlert(this.translate.get('message_member_barcode_not_matching')['value']);
      this.text_member_unregistered = this.translate.get('message_member_barcode_not_matching')['value'];
    }
  }

  changeBright() {
    if (this.is_bright) {
      this.setDark();
    } else {
      this.setBright();
    }
  }

  setBright() {
    if (this.page_name == 'coupon') {
      return;
    }
    if (!this.disp_barcode) {
      return;
    }
    if (!this.is_app) {
      return;
    }
    if (this.is_bright) {
      return;
    }

    this.is_bright = true;
    this.comProv.setBright();
  }

  setDark() {
    if (this.page_name == 'coupon') {
      return;
    }
    if (!this.is_app) {
      return;
    }
    if (!this.is_bright) {
      return;
    }

    this.is_bright = false;
    this.comProv.setDark();
  }

  /*generateJan13(user_id, format) {
    let filled = this.fillTemplate(format, user_id);
    let numeric = filled.replace(/\D/g, ''); // 数字だけ抽出

    if (numeric.length !== 12) {
      throw new Error(`Formatted code must be 12 digits, got: ${numeric}`);
    }

    let check_digit = this.calculateCheckDigit(numeric);
    return numeric + check_digit;
  }

  fillTemplate(format, number) {
    let digits = number.toString().split('').reverse(); // 右から使う
    let result = '';
    let digitIndex = 0;

    for (let i = format.length - 1; i >= 0; i--) {
      if (format[i] === '#') {
        let str_idx = digits[digitIndex++];
        result = (str_idx ? str_idx : '0') + result; // 足りなければゼロ
      } else {
        result = format[i] + result;
      }
    }

    if (digitIndex < digits.length) {
      throw new Error('Number is too long for the given format');
    }

    return result;
  }

  calculateCheckDigit(jan12) {
    let digits = jan12.split('').map(Number);
    let sum = 0;
    for (let i = 0; i < digits.length; i++) {
      sum += digits[i] * (i % 2 === 0 ? 1 : 3);
    }
    let mod = sum % 10;
    return mod === 0 ? 0 : 10 - mod;
  }*/
}


// WEBPACK FOOTER //
// ./src/components/member-card/member-card.ts